<template>
  <v-banner
    v-if="endpointStatus"
    :color="endpointStatus.severity"
    icon="mdi-cloud-off-outline"
    :bg-color="endpointStatus.severity"
  >
    <template #text>
      <EmBody2 bold>
        {{ endpointStatus.message }}
      </EmBody2>
    </template>
    <template #actions>
      <EmTerciaryButton color="white" @click="endpointStatus = null">
        Close
      </EmTerciaryButton>
    </template>
  </v-banner>
</template>
<script setup>
import { MS_PER } from '@/services/types/Time'
import { Service } from '@/services/helpers/ServiceHelper'
const endpointStatus = ref(null)
const getStatus = async () => {
  const statusToShow = await Service.api.statusService.getEndpointStatus()
  if (statusToShow) {
    endpointStatus.value = statusToShow.message ? statusToShow : null
  }
}
getStatus()
setInterval(getStatus, MS_PER.Minute * 5)
</script>
